import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex flex-wrap space-y-2 md:space-x-2 md:flex-nowrap md:space-y-0" }
const _hoisted_3 = { class: "flex w-full md:w-4/5" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
], -1)
const _hoisted_6 = { class: "w-full md:w-1/5" }
const _hoisted_7 = { class: "flex flex-wrap space-x-2 md:flex-nowrap" }
const _hoisted_8 = { class: "w-full mt-8 overflow-x-auto" }
const _hoisted_9 = { class: "w-full table-auto" }
const _hoisted_10 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_11 = { scope: "col" }
const _hoisted_12 = { class: "flex items-center justify-between w-full px-2 py-2 capitalize" }
const _hoisted_13 = { scope: "col" }
const _hoisted_14 = { class: "flex items-center justify-between w-full px-2 py-2 capitalize" }
const _hoisted_15 = { scope: "col" }
const _hoisted_16 = { class: "flex items-center justify-between w-full px-2 py-2 capitalize" }
const _hoisted_17 = { scope: "col" }
const _hoisted_18 = { class: "relative flex items-center justify-between w-full px-2 py-2 capitalize" }
const _hoisted_19 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_20 = { class: "py-6 pr-12 md:py-3 whitespace-nowrap" }
const _hoisted_21 = { class: "py-2 pr-12 capitalize whitespace-nowrap" }
const _hoisted_22 = { class: "py-2 pr-12 capitalize whitespace-nowrap" }
const _hoisted_23 = { class: "py-2 pr-12 capitalize whitespace-nowrap" }
const _hoisted_24 = { class: "py-2 capitalize whitespace-nowrap flex" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]

import { ref } from "vue";
import { useRoute } from "vue-router";

import RoleGuard from "./RoleGuard.vue";
import TitleHeader from "./TitleHeader.vue";
import RouterButton from "./RouterButton.vue";
import PaginationBar from "./PaginationBar.vue";
import SortableTableHeader from "./tables/SortableTableHeader.vue";
import FilterTableHeader from "./tables/FilterTableHeader.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import EditOrganisationNameModal from "@/components/modals/EditOrganisationNameModal.vue";

import api from "@/api/api";
import { useGlobalStore } from "@/store";
import { useI18n } from "vue-i18n";
import { PaginationMeta } from "@/types";
import { useFilters } from "@/composables/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganisationList',
  async setup(__props) {

let __temp: any, __restore: any

const { t: $t } = useI18n();
const route = useRoute();
const globalStore = useGlobalStore();

const { filters, getFiltersFromQuery, sortBy, filter, setFilter, resetFilters } = useFilters(route);

const archivedFilters = [
  { key: "yes", value: "true" },
  { key: "no", value: "false" },
];

const organisations = ref();
const meta = ref({} as PaginationMeta);
const isDeleteConfirmationOpen = ref(false);
const organisationToDelete = ref(0);
const organisationToDeleteName = ref("");
const isEditNameModalOpen = ref(false);
const organisationToEdit = ref(0);
const organisationToEditName = ref("");
const isSavingName = ref(false);

async function search() {
  const response = await api.organisations.listOrganisations(filters.value);
  organisations.value = response.data.organisations;
  meta.value = response.meta as PaginationMeta;
}

async function canDeleteOrganisation(id: number) {
  try {
    const response = await api.organisations.canDeleteOrganisation(id);
    return response.data.canDelete;
  } catch (error) {
    console.log("ERROR", error);
    return false;
  }
}

async function openDeleteConfirmation(id: number, name: string) {
  const canDelete = await canDeleteOrganisation(id);
  if (!canDelete) {
    globalStore.toast("ERROR", $t("organisation-cannot-be-deleted"));
    return;
  }
  organisationToDelete.value = id;
  organisationToDeleteName.value = name;
  isDeleteConfirmationOpen.value = true;
}

async function deleteOrganisation() {
  const id = organisationToDelete.value;
  try {
    await api.organisations.deleteOrganisation(id);
    globalStore.toast("SUCCESS", $t("organisation-deleted-successfully"));
    await search();
  } catch (error) {
    globalStore.toast("ERROR", $t("organisation-deletion-failed"));
  } finally {
    isDeleteConfirmationOpen.value = false;
    organisationToDelete.value = 0;
    organisationToDeleteName.value = "";
  }
}

async function archiveOrganisation(id: number) {
  try {
    await api.organisations.archiveOrganisation(id);
    globalStore.toast("SUCCESS", $t("organisation-archived"));
    await search();
  } catch (error) {
    globalStore.toast("ERROR", $t("organisation-archiving-failed"));
  }
}

function openEditNameModal(id: number, name: string) {
  organisationToEdit.value = id;
  organisationToEditName.value = name;
  isEditNameModalOpen.value = true;
}

async function saveOrganisationName(name: string) {
  isSavingName.value = true;
  try {
    await api.organisations.updateOrganisation(organisationToEdit.value, { name });
    globalStore.toast("SUCCESS", $t("organisation-name-updated"));
    await search();
  } catch (error) {
    globalStore.toast("ERROR", $t("organisation-name-update-failed"));
  } finally {
    isSavingName.value = false;
    isEditNameModalOpen.value = false;
    organisationToEdit.value = 0;
    organisationToEditName.value = "";
  }
}

async function unarchiveOrganisation(id: number) {
  try {
    await api.organisations.unarchiveOrganisation(id);
    globalStore.toast("SUCCESS", $t("organisation-unarchived"));
    await search();
  } catch (error) {
    globalStore.toast("ERROR", $t("organisation-unarchiving-failed"));
  }
}
getFiltersFromQuery();
if (!filters.value.archived) {
  filters.value.archived = "false";
}
;(
  ([__temp,__restore] = _withAsyncContext(() => search())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _unref($t)('trained-by-organisations')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "search",
            id: "search",
            onKeydown: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args)), ["enter"])),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).query) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded-l",
            placeholder: _unref($t)('search'),
            required: ""
          }, null, 40, _hoisted_4), [
            [_vModelText, _unref(filters).query]
          ]),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args))),
            type: "submit",
            class: "flex items-center h-10 px-4 py-2 space-x-2 text-white capitalize rounded-r whitespace-nowrap bg-primary hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300"
          }, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_unref($t)("search")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(RoleGuard, { roles: ['admin', 'users-admin', 'courses-admin', 'clubs-admiun'] }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(RouterButton, {
                  type: "secondary",
                  loading: false,
                  disabled: false,
                  to: { path: '/dashboard/organisations/new' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("add-new-trained-by-organisation")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("table", _hoisted_9, [
        _createElementVNode("thead", _hoisted_10, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(_unref($t)("name")), 1),
                _createVNode(SortableTableHeader, {
                  label: "Name",
                  column: "name",
                  onSort: _unref(sortBy)
                }, null, 8, ["onSort"])
              ])
            ]),
            _createElementVNode("th", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_unref($t)("play-included-organisation")), 1),
                _createVNode(SortableTableHeader, {
                  label: "Play Included Organisation",
                  column: "play_included_organisation",
                  onSort: _unref(sortBy)
                }, null, 8, ["onSort"])
              ])
            ]),
            _createElementVNode("th", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", null, _toDisplayString(_unref($t)("region")), 1),
                _createVNode(SortableTableHeader, {
                  label: "Region",
                  column: "country",
                  onSort: _unref(sortBy)
                }, null, 8, ["onSort"])
              ])
            ]),
            _createElementVNode("th", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(_unref($t)("archived")), 1),
                _createVNode(FilterTableHeader, {
                  label: "archived",
                  currentValue: _unref(filters).archived,
                  filters: archivedFilters,
                  onChange: _unref(setFilter),
                  onReset: _unref(resetFilters),
                  isObjectArray: true
                }, null, 8, ["currentValue", "onChange", "onReset"])
              ])
            ]),
            _createElementVNode("th", _hoisted_19, _toDisplayString(_unref($t)("actions")), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organisations.value, (organisation) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "border-b border-gray-400",
              key: organisation.id
            }, [
              _createElementVNode("td", _hoisted_20, _toDisplayString(organisation.name), 1),
              _createElementVNode("td", _hoisted_21, _toDisplayString(organisation.play_included_organisation ? 'Yes' : 'No'), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(organisation.country), 1),
              _createElementVNode("td", _hoisted_23, _toDisplayString(organisation.deleted ? _unref($t)("yes") : _unref($t)("no")), 1),
              _createElementVNode("td", _hoisted_24, [
                _createVNode(_component_router_link, {
                  to: `/dashboard/users?page=1&search=${organisation.name}&search_type=organisations`,
                  class: "underline text-blue"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("view")), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                (!['Play Included', 'Play Included CIC'].includes(organisation.name))
                  ? (_openBlock(), _createBlock(RoleGuard, {
                      key: 0,
                      roles: ['admin']
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (openEditNameModal(organisation.id, organisation.name)),
                          class: "ml-4 underline capitalize"
                        }, _toDisplayString(_unref($t)("edit")), 9, _hoisted_25)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (!['Play Included', 'Play Included CIC'].includes(organisation.name))
                  ? (_openBlock(), _createBlock(RoleGuard, {
                      key: 1,
                      roles: ['admin']
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (openDeleteConfirmation(organisation.id, organisation.name)),
                          class: "ml-4 underline text-danger capitalize"
                        }, _toDisplayString(_unref($t)("delete")), 9, _hoisted_26)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (!organisation.deleted && !['Play Included', 'Play Included CIC'].includes(organisation.name))
                  ? (_openBlock(), _createBlock(RoleGuard, {
                      key: 2,
                      roles: ['admin']
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (archiveOrganisation(organisation.id)),
                          class: "ml-4 underline text-danger capitalize"
                        }, _toDisplayString(_unref($t)("archive")), 9, _hoisted_27)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (organisation.deleted)
                  ? (_openBlock(), _createBlock(RoleGuard, {
                      key: 3,
                      roles: ['admin']
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (unarchiveOrganisation(organisation.id)),
                          class: "ml-4 underline text-success capitalize"
                        }, _toDisplayString(_unref($t)("unarchive")), 9, _hoisted_28)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(PaginationBar, { meta: meta.value }, null, 8, ["meta"]),
    _createVNode(ConfirmationModal, {
      buttonText: "Delete Organisation",
      class: "danger",
      isOpen: isDeleteConfirmationOpen.value,
      onDelete: deleteOrganisation,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (isDeleteConfirmationOpen.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref($t)("delete-organisation-confirmation")) + ": " + _toDisplayString(organisationToDeleteName.value), 1)
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode(EditOrganisationNameModal, {
      isOpen: isEditNameModalOpen.value,
      organisationName: organisationToEditName.value,
      isSaving: isSavingName.value,
      onSave: saveOrganisationName,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isEditNameModalOpen.value = false))
    }, null, 8, ["isOpen", "organisationName", "isSaving"])
  ], 64))
}
}

})